import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the CarpetasPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'carpetas',
})
export class CarpetasPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return value.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/pipes/carpetas/carpetas.ts